import Group from 'components/utils/Group'
import BedbankOfferPriceDetails from './BedbankOfferPriceDetails'
import WalledContent from 'components/Common/WalledContent'
import OfferTileLoggedInButtons from '../OfferListTiles/Support/OfferTileLoggedInButtons'
import { ViewOfferButton } from './ViewOfferButton'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate
  variant?: 'default' | 'condensed'
  selectedDatesAndRoomsFilter?: App.OfferListFilters
}

function BedbankOfferCardPriceDetails(props: Props) {
  const { offer, variant = 'default', selectedDatesAndRoomsFilter } = props

  const wall =
    <OfferTileLoggedInButtons
      discountLabelAlign="end"
      align="right"
      fullWidth={false}
    />

  return <Group direction="horizontal" gap={8} horizontalAlign="space-between" verticalAlign="end">
    <WalledContent enforced={offer.walledGarden} hidePricing={offer.hidePricing} wall={wall}>
      <BedbankOfferPriceDetails offer={offer} selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter} />
      <ViewOfferButton variant={variant} />
    </WalledContent>
  </Group>
}

export default BedbankOfferCardPriceDetails
